import { render } from "./FaqContainer.vue?vue&type=template&id=18b68a2f"
import script from "./FaqContainer.vue?vue&type=script&lang=js"
export * from "./FaqContainer.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/herodao/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__